import React from "react";
import { Outlet } from "react-router-dom";
import HeaderPremium from "./HeaderPremium";
import FooterPremium from "./FooterPremium";

const Layout = () => {
  return (
    <div className="app-shell">
      <HeaderPremium className="zedro-header" />

      <main>
        <Outlet />
      </main>

      <FooterPremium variant="public" />
    </div>
  );
};

export default Layout;